<template>
  <div class="mapAlign" style="height:100%;">
    <toolBar @succeeUpload="succeeUpload"
             @exportData="sumitAlignData"
             @hideMesh="hideMesh"
             @initAlign="initAlign"
             @mapApply="mapApply"
             @downLoadSvg="downLoadSvg"
             @mapEdit="mapEdit"
             @roadEdit="roadEdit"
             @getCameraMatirx="getCameraMatirx"
             @handleDeleteImg="handleDeleteImg"></toolBar>
    <div class="mapBox">
      <div class="canvasBox">
        <canvas id="canvas2D"></canvas>
        <div id="canvas3D" :style="`opacity: ${meshOpacity / 10}; visibility: ${isCanvas3DShow ? 'visible' : 'hidden'}`"></div>
      </div>
      <mapAlignFormPanel @miniRotate="meshRotate"
                         @setZoom="scale3D"
                         @onSizeConfirm="onSizeConfirm"
                         :jsonData="jsonData"
                         :maxSize="maxSize"
                         class="mapAlignFormPanel"></mapAlignFormPanel>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import { Stage, FloorModel, OrthographicView, OrbitControl, AlignmentUtils, SvgUtils } from '@aibee/owlly';
import shortid from 'shortid';
import Axios from 'axios';
import { BMapSvgUtil, Floor, OwllySvgUtil } from '@aibee/bmap';
import { Loading } from 'element-ui';
import toolBar from '@/components/mapComponents/toolBar.vue';
import mapAlignFormPanel from '@/components/mapComponents/mapAlignFormPanel.vue';
import { listPanoramas, mapUpload, mapDelete, updateFloor, syncMapAlign, uploadBase64 } from '@/api/map';
import eventHub from '@/utils/eventHub';
import { events } from '@/utils/events';
import request from '@/utils/request';
import util from './roadMapComponent/util';

const ALIGN_SOURCE_MAP = {
  '2d': 'floor_2dmap_align_param',
  '3d': 'floor_3dmap_align_param',
  cmap: 'floor_cmap_align_param',
};
const URL_ROOT = 'https://vr.aibee.cn';
const SECRET = 'secret=U4LOTsSWEASOCXNl4lzyg0rOyGztm1so';
const DEFAULT_WORLD_MATRIX = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 100, 1];
// 单位矩阵
const UNIT_MATRIX = [1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1];
export default {
  name: 'mapAlign',
  components: { toolBar, mapAlignFormPanel },
  computed: {
    ...mapGetters(['floorInfo']),
    source() {
      return this.$route.params.source;
    },
    placeId() {
      return this.$route.query.place_id;
    },
    floorId() {
      return this.$route.query.floor_id;
    },
    vrId() {
      return this.$route.query.vr_id;
    },
  },
  data() {
    return {
      uploadImage: null,
      controller: null,
      view: null,
      stage: null,
      model: null,
      CANVAS_WIDTH: 0,
      CANVAS_HEIGHT: 0,
      canvas3D: null,
      canvas2D: null,
      ctx: null,
      svgImg: null,
      scrollStartXY: [],
      scrollDurationXY: [],
      svgOffsetX: 0,
      svgOffsetY: 0,
      XRadio: 0.5,
      YRadio: 0.5,
      isSvgMoving: false,
      isSvgScale: true,
      scalePercent: 1,
      AlignmentUtils: null,
      jsonData: {},
      gisToSvg: [],
      svgToGis: [],
      isCanvas3DShow: true,
      initData: null,
      maxSize: '',
      imgUrl: '',
      meshOpacity: 12,
      mesh_id: null,
      mesh_width: null,
      mesh_height: null,
      labelingResult: {
        blockPoints: [],
        blocks: [],
        destPoints: [],
      },
    };
  },
  mounted() {
    if (this.floorInfo) {
      this.init();
    }
    // this.loadMeshId(this.vrId);
  },
  watch: {
    // eslint-disable-next-line func-names
    floorId(val) {
      // if (!this.isCanvas3DShow) {
      //   this.hideMesh();
      // }
      this.init();
      this.loadAlignData();
    },
    vrId(val) {
      this.loadMeshId(val);
    },
    floorInfo() {
      // if (!this.isCanvas3DShow) {
      //   this.hideMesh();
      // }
      this.init();
      // this.loadAlignData();
    },
    async source(val) {
      // if (!this.isCanvas3DShow) {
      //   this.hideMesh();
      // }
      await this.init();
      this.loadAlignData();
    },
  },
  methods: {
    ...mapActions(['getFloorInfoInit']),
    async loadMeshId(val) {
      if (val) {
        try {
          const {
            data: {
              data: {
                modelPath,
              },
            },
          } = await Axios({
            url: `${URL_ROOT}/v1/list-panoramas?${SECRET}`,
            method: 'POST',
            data: {
              store_id: this.vrId,
            },
          });
          this.mesh_id = modelPath;
        } catch (error) {
          this.$message.error('模型加载异常');
        }
      } else {
        this.mesh_id = '';
      }
    },
    async init() {
      this.canvas2D = document.getElementById('canvas2D');
      this.canvas3D = document.getElementById('canvas3D');
      this.jsonData = {};
      this.meshOpacity = 12;
      this.svgOffsetX = 0;
      this.svgOffsetY = 0;
      this.XRadio = 0.5;
      this.YRadio = 0.5;
      await this.loadMeshId(this.vrId);
      if (this.floorInfo[1]) {
        if (this.floorInfo[1][ALIGN_SOURCE_MAP[this.source]]) {
          if (Object.keys(JSON.parse(this.floorInfo[1][ALIGN_SOURCE_MAP[this.source]])).length > 0) {
            this.initData = JSON.parse(this.floorInfo[1][ALIGN_SOURCE_MAP[this.source]]);
          }
        }
        this.createImg();
      }
    },
    initMesh() {
      const stage = new Stage();
      this.stage = stage;
      // 调试用
      stage.setStatsEnabled(false);
      stage.setAxesEnabled(false);

      // 模型
      const model = new FloorModel(this.mesh_id);
      this.model = model;
      stage.bindElement(model);

      // 平行视图
      const view = new OrthographicView(this.canvas3D);
      this.view = view;
      view.setClearColor('#fff', 0);
      stage.bindView(view);

      // 控制器
      const controller = new OrbitControl(view);
      this.controller = controller;
      controller.setDampingEnabled(false);
      controller.setKeysEnabled(false);
      controller.setRotateEnabled(false);
      controller.setZoomEnabled(false);
      controller.setPolarAngle(0, 0);

      stage.bindController(controller);
      this.loadAlignData();
      this.isCanvas3DShow = false;
    },
    loadMesh() {
      if (this.model) {
        this.stage.disposeElement(this.model);
        this.stage.forceResize();
        // this.view.setViewingWidth(this.CANVAS_WIDTH);
        // this.view.setViewingHeight(this.CANVAS_HEIGHT);
        this.model = new FloorModel(this.mesh_id);
        this.stage.bindElement(this.model);
      } else {
        this.initMesh();
      }
    },
    async succeeUpload(val) {
      if (!this.$route.query.floor_id) {
        this.$message.error('请选择楼层');
      }
      const params = {
        floor_id: this.$route.query.floor_id,
        map_type: this.$route.params.source,
        map_file: val.map_file,
        img_type: val.img_type,
      };
      const { data } = await mapUpload(params);
      this.uploadImage = data.map_url;
      this.requestSvg(this.uploadImage);
      this.getFloorInfoInit();
    },

    createImg() {
      const floorData = this.floorInfo[1];
      if (!floorData) return;
      const IMG_SOURCE_MAP = {
        '2d': 'floor_2dmap',
        '3d': 'floor_3dmap',
        cmap: 'floor_cmap',
      };
      this.imgUrl = this.floorInfo[1][IMG_SOURCE_MAP[this.source]];
      this.requestSvg(this.imgUrl);
    },
    blobToDataURI(blob) {
      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onload = function (e) {
          resolve(e.target.result);
        };
        reader.readAsDataURL(blob);
      });
    },
    async convertToJsonUrl(matrix) {
      if (!this.initData) {
        this.initData = this.jsonData;
      }
      // const shapes = await SvgUtils.parseSvgToShapes(this.imgUrl, matrix);
      const shapes = await BMapSvgUtil.parseSvgToShapes(this.imgUrl, matrix);
      const shapeDataArray = shapes.map(s => (s.getData()));
      const blobURL = new Blob([JSON.stringify(shapeDataArray)], { type: 'text/json' });
      let base64 = await this.blobToDataURI(blobURL);
      base64 = base64.split('data:text/json;base64,').pop();
      const name = `${this.floorInfo[0].name}_${this.floorInfo[1].floor}_${this.floorInfo[1].id}_cmap_${shortid.generate()}.json`;
      try {
        const res = await uploadBase64(name, base64);
        return res.data.data[0].url;
      } catch (error) {
        return '';
      }
    },
    requestSvg(url) {
      this.ctx = this.canvas2D.getContext('2d');
      this.ctx.clearRect(0, 0, this.CANVAS_WIDTH, this.CANVAS_HEIGHT);
      this.svgImg = new Image();
      if (this.source === 'cmap') {
        fetch(url)
          .then(res => res.text())
          .then((res) => {
            this.svgImg.src = `data:image/svg+xml;base64,${window.btoa(unescape(encodeURIComponent(res.replace(/u id/g, 'uid'))))}`;

            this.svgImg.onload = () => {
              // drawImage 可以用HTMLImageElement，HTMLCanvasElement或者HTMLVideoElement作为参数
              // this.ctx.drawImage(this.svgImg, 0, 0, 100, 100);
              this.initCanvas();
            };
          });
      } else {
        this.svgImg.src = url;
        this.svgImg.onload = () => {
          this.initCanvas();
        };
      }
    },
    initCanvas() {
      this.initMapBox();
      this.loadMesh();
      this.scale2D(0);
      this.initEvent();
      this.getCameraMatirx();
      if (!this.vrId && this.initData.mesh_width && this.initData.mesh_height) {
        this.onSizeConfirm(this.initData.mesh_width, this.initData.mesh_height, this.initData.scale3D);
      }
      this.initJsonData();
    },
    initJsonData() {
      if (this.initData) {
        this.svgToGis = this.initData.svgToGis;
        this.gisToSvg = this.initData.gisToSvg;
        this.jsonData = this.initData;
      }
    },
    handleDeleteImg() {
      if (!this.floorId) {
        this.$message({
          message: '请选择楼层',
          type: 'warning',
        });
        return;
      }
      mapDelete({ floor_id: this.floorId, map_type: this.source }).then((res) => {
        if (res.data.status === 'NotFound') {
          this.$message({
            message: '请先打开CAD',
            type: 'warning',
          });
          return;
        }
        this.requestSvg();
        this.getFloorInfoInit();
        this.jsonData = {};
        this.$message({
          message: '删除成功',
          type: 'success',
        });
      });
    },
    unbindEvent() {
      if (!this.canvasBox) return;
      this.canvasBox.removeEventListener('mousewheel', this.mousewheelEvent);
      this.canvasBox.removeEventListener('mousedown', this.mousedownEvent);
      this.canvasBox.removeEventListener('mousemove', this.mousemoveEvent);
      this.canvasBox.removeEventListener('mouseup', this.mouseupEvent);
      this.canvasBox.removeEventListener('keydown', this.keydownEvent);
      this.canvasBox.removeEventListener('keyup', this.keyupEvent);
    },
    initEvent() {
      this.canvasBox.addEventListener('mousewheel', this.mousewheelEvent, true);
      this.canvasBox.addEventListener('mousedown', this.mousedownEvent);
      this.canvasBox.addEventListener('mousemove', this.mousemoveEvent);
      this.canvasBox.addEventListener('mouseup', this.mouseupEvent);
      document.addEventListener('keydown', this.keydownEvent);
      document.addEventListener('keyup', this.keyupEvent);
    },
    keydownEvent(e) {
      switch (e.keyCode) {
        case 18:
          this.controller.setRotateEnabled(true);
          break;
        default:
          break;
      }
    },
    keyupEvent(e) {
      switch (e.keyCode) {
        case 18:
          this.controller.setRotateEnabled(false);
          break;
        default:
          break;
      }
    },
    mousedownEvent(e) {
      if (!e.altKey && this.isSvgScale && e.button === 2) {
        this.isSvgMoving = true;
        this.scrollStartXY = [e.clientX, e.clientY];
        this.scrollDurationXY = [e.clientX, e.clientY];
      }
    },
    mouseupEvent(e) {
      if (this.scrollDurationXY.length === 2) {
        this.isSvgMoving = false;
        this.scrollStartXY = [];
        this.scrollDurationXY = [];
      }
    },
    mousemoveEvent(e) {
      e.preventDefault();
      this.initData = null;
      if (!e.altKey && this.scrollDurationXY.length === 2 && this.isCanvas3DShow) {
        this.svgOffsetX -= ((this.scrollDurationXY[0] - e.clientX) / this.scalePercent);
        this.svgOffsetY -= ((this.scrollDurationXY[1] - e.clientY) / this.scalePercent);
        // 为了使svg图片按照画布中心缩放，计算图片原点坐标的到画布中心的距离
        this.XRadio = (this.CANVAS_WIDTH / 2 - this.svgOffsetX) / this.CANVAS_WIDTH;
        this.YRadio = (this.CANVAS_HEIGHT / 2 - this.svgOffsetY) / this.CANVAS_HEIGHT;
        this.drawCanvas2D();
        this.scrollDurationXY = [e.clientX, e.clientY];
        this.getCameraMatirx();
      }
    },
    mousewheelEvent(e) {
      e.preventDefault();
      const delta = e.wheelDeltaY;
      if (this.svgImg && !e.altKey && this.isSvgScale && this.isCanvas3DShow) {
        if (delta > 0) {
          this.scale2D(-1);
        } else if (delta < 0) {
          this.scale2D(1);
        }
      } else if (delta > 0) {
        this.scale3D(-1);
      } else if (delta < 0) {
        this.scale3D(1);
      }
      this.getCameraMatirx();
    },
    initMapBox() {
      this.canvasBox = document.querySelector('.canvasBox');
      const canvasWHRadio = this.canvasBox.offsetWidth / this.canvasBox.offsetHeight;
      const imageWHRadio = this.svgImg.width / this.svgImg.height;
      if (imageWHRadio > canvasWHRadio) {
        this.CANVAS_WIDTH = this.canvasBox.offsetWidth;
        this.CANVAS_HEIGHT = this.canvasBox.offsetWidth / imageWHRadio;
      } else {
        this.CANVAS_WIDTH = this.canvasBox.offsetHeight * imageWHRadio;
        this.CANVAS_HEIGHT = this.canvasBox.offsetHeight;
      }

      this.IMG_WIDTH = this.svgImg.width;
      this.IMG_HEIGHT = this.svgImg.height;
      this.baseScale = this.CANVAS_WIDTH / this.IMG_WIDTH;
      this.canvas2D.width = this.CANVAS_WIDTH;
      this.canvas2D.height = this.CANVAS_HEIGHT;
      this.canvas3D.style.width = `${this.CANVAS_WIDTH}px`;
      this.canvas3D.style.height = `${this.CANVAS_HEIGHT}px`;
    },
    scale2D(value) {
      if (value > 0 && this.scalePercent * (0.99 ** value) <= 1) {
        this.ctx.drawImage(
          this.svgImg,
          this.CANVAS_WIDTH * (1 - this.scalePercent) / 2 + this.svgOffsetX,
          this.CANVAS_HEIGHT * (1 - this.scalePercent) / 2 + this.svgOffsetY,
          this.IMG_WIDTH * this.baseScale * this.scalePercent,
          this.IMG_HEIGHT * this.baseScale * this.scalePercent,
        );
        return;
      }
      this.scalePercent = this.scalePercent * (0.99 ** value);
      this.scale3D(value);
      const imageWHRadio = this.svgImg.width / this.svgImg.height;
      // this.svg.node.setAttribute('style', `zoom:${this.scalePercent / 100}`);
      this.drawCanvas2D();
    },
    scale3D(value) {
      if (!this.isCanvas3DShow) return;
      const scale3DPercent = this.controller.getZoom() * (0.99 ** value);
      this.controller.setZoom(scale3DPercent);
      this.getCameraMatirx();
    },
    drawCanvas2D() {
      this.ctx.clearRect(0, 0, this.CANVAS_WIDTH, this.CANVAS_HEIGHT);
      this.ctx.drawImage(
        this.svgImg,
        this.CANVAS_WIDTH * (1 - this.scalePercent) * this.XRadio + this.svgOffsetX,
        this.CANVAS_HEIGHT * (1 - this.scalePercent) * this.YRadio + this.svgOffsetY,
        this.IMG_WIDTH * this.baseScale * this.scalePercent,
        this.IMG_HEIGHT * this.baseScale * this.scalePercent,
      );
    },
    getCameraMatirx() {
      if (!this.view) return;
      const svgImgScale = this.scalePercent;
      const transformMatrices = AlignmentUtils.getTransformMatrices(this.view, svgImgScale, [this.svgOffsetX, this.svgOffsetY], [this.IMG_WIDTH, this.IMG_HEIGHT]);
      this.jsonData = {
        scale2D: svgImgScale,
        scale3D: this.controller.getZoom(),
        transformMatrices,
        svgToGis: this.svgToGis,
        gisToSvg: this.gisToSvg,
        img_width: this.IMG_WIDTH,
        img_height: this.IMG_HEIGHT,
        mesh_width: this.mesh_width,
        mesh_height: this.mesh_height,
      };
    },
    async sumitAlignData(data) {
      this.getCameraMatirx();
      this.$confirm('保存确认', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        const loading = Loading.service({ text: '保存中。。。' });
        try {
          const alignParamsKeyName = ALIGN_SOURCE_MAP[this.source];
          if (!alignParamsKeyName || !this.jsonData) return;
          if (!this.jsonData.transformMatrices) {
            this.$message.error('对齐数据异常;请重新加载');
            return;
          }
          const mapJsonUrl = await this.convertToJsonUrl(this.initData?.transformMatrices.upTrans || this.jsonData.transformMatrices.upTrans || DEFAULT_WORLD_MATRIX);
          const d2MapJsonUrl = await this.convertToJsonUrl(UNIT_MATRIX);
          if (!mapJsonUrl) return;
          await updateFloor({
            data: {
              id: this.floorId,
              [alignParamsKeyName]: this.jsonData,
              floor_cmap_json: mapJsonUrl,
              floor_cmap_json2d: d2MapJsonUrl,
            },
          });
          this.getFloorInfoInit();
          await this.syncMapParams(this.imgUrl, JSON.stringify(this.jsonData));
          if (this.source === 'cmap' && this.imgUrl) {
            await this.queryLabelingResult();
            await request({
              url: '/deployment-service/blockmarker/post_labeling_result',
              method: 'post',
              data: {
                floor_id: this.floorId,
                place_id: this.placeId,
                result: this.labelingResult,
              },
            });
          }
          loading.close();
          this.$message.success('保存成功');
        } catch (error) {
          loading.close();
          this.$message.error('保存失败');
        }
      });
    },
    onSizeConfirm(width, height, zoomScale) {
      this.model.loadBox(width, height, 3);
      this.mesh_width = width;
      this.mesh_height = height;
      const zoom = Math.min(this.CANVAS_WIDTH / width, this.CANVAS_HEIGHT / height) / 100;
      this.controller.setZoom(zoomScale || zoom);
      // this.getCameraMatirx();
    },
    async syncMapParams(url, align_data) {
      const { vrId: vr_id, source } = this;
      const map_type = source === '2d' ? 1 : source === 'cmap' ? 2 : null;
      if (!map_type) {
        return;
      }
      await syncMapAlign({
        url,
        vr_id,
        map_type,
        align_data,
      });
    },
    loadAlignData() {
      if (this.initData && this.controller) {
        this.scalePercent = parseFloat(this.initData.scale2D);
        this.controller.setZoom(parseFloat(this.initData.scale3D));
        this.controller.setCameraWorldMatrix(this.initData.transformMatrices.matrixWorld || DEFAULT_WORLD_MATRIX);
        this.maxSize = this.initData.maxSize ? `${this.initData.maxSize}` : '';
      } else if (this.controller) {
        this.controller.setZoom(1);
        this.scalePercent = 1;
        this.controller.setCameraWorldMatrix(DEFAULT_WORLD_MATRIX);
        this.maxSize = '';
      }
    },
    initAlign() {
      this.controller.setZoom(1);
      this.scalePercent = 1;
      this.controller.setCameraWorldMatrix(DEFAULT_WORLD_MATRIX);
      this.getCameraMatirx();
    },
    hideMesh() {
      this.meshOpacity -= 2;
      if (this.meshOpacity === 0) {
        this.isCanvas3DShow = false;
        this.meshOpacity = 12;
      } else {
        this.isCanvas3DShow = true;
      }
      this.$nextTick(() => { this.view.resize(); });
    },
    meshRotate(radius) {
      let result = this.controller.getCameraRotation() + radius;
      const PI = Math.PI;
      if (result < -PI) {
        result = 2 * PI + (result % (2 * PI));
      } else if (result > PI) {
        result = -2 * PI + (result % (2 * PI));
      }
      this.controller.setCameraRotation(result);
    },
    // 地图block位置查询
    async queryLabelingResult() {
      const res = await request({
        url: '/deployment-service/blockmarker/labeling_result',
        get: 'get',
        params: {
          place_id: this.placeId,
          floor_id: this.floorId,
        },
      });
      if (res.data && res.data[0] && res.data[0].blockmarker_labeling_results) {
        this.labelingResult.blockPoints = res.data[0].blockmarker_labeling_results.blockPoints;
        this.labelingResult.destPoints = res.data[0].blockmarker_labeling_results.destPoints;
      }
      const blocks = await this.loadSvg(this.imgUrl);
      this.labelingResult.blocks = blocks;
    },

    //

    // 地图块中心点计算
    async loadSvg(svgPath) {
      const svgObjects = await util.loadSVGFromURL(svgPath);
      const res = [];
      svgObjects.forEach((obj) => {
        if (!obj.s) { // 这个是poi转成的circle 不属于block 不参与
          return;
        }
        if (!obj.s.length) return;
        const t = util.getPositionTransform([obj.s[0].centroid[0], obj.s[0].centroid[1]], this.jsonData.transformMatrices.upTrans);
        res.push({
          graphic_id: obj.name,
          center_x_2d: obj.s[0].centroid[0],
          center_y_2d: obj.s[0].centroid[1],
          center_x_3d: t.x,
          center_y_3d: t.y,
        });
      });
      return res;
    },

    async initBmapData() {
      // const baseUrl = 'https://nav-test.aibee.cn'; // 测试环境
      const versionData = await Axios.get(`/bmap/version?place_id=${this.$route.query.place_id}&floor_id=${this.$route.query.floor_id}`);
      this.versionData = versionData.data.data;
      if (this.versionData.length <= 0) {
        this.$message('暂无地图版本');
        return;
      }
      const versionId = this.versionData.find(e => e.is_used).version_id || this.versionData[0].version_id;
      const mapData = await Axios.get(`/bmap/data?place_id=${this.$route.query.place_id}&floor_id=${this.$route.query.floor_id}&version_id=${versionId}&content=1`);
      const floor = new Floor();
      try {
        // loadData不解析 添加的加类型为unknown的地面 导致svg获取大小错误
        if (
          mapData.data &&
          mapData.data.data &&
          mapData.data.data[0] &&
          mapData.data.data[0].content &&
          mapData.data.data[0].content.layers &&
          mapData.data.data[0].content.layers[0] &&
          mapData.data.data[0].content.layers[0].elements &&
          mapData.data.data[0].content.layers[0].elements.length
        ) {
          mapData.data.data[0].content.layers[0].elements.forEach((e) => {
            if (e.id === '$canvas' && e.e_type === 'unknown') {
              e.e_type = 'graphic';
            }
          });
        }
        // debugger;
        floor.loadData(mapData.data.data[0].content);
        const convertRes = BMapSvgUtil.convertFloor2SvgString(floor);
        const svg = convertRes.svg;
        this.gisToSvg = convertRes.gisToSvg;
        this.svgToGis = convertRes.svgToGis;
        this.jsonData.gisToSvg = this.gisToSvg;
        this.jsonData.svgToGis = this.svgToGis;
        // const s = new XMLSerializer().serializeToString(svg);
        const src = window.btoa(unescape(encodeURIComponent(convertRes.svg)));
        // bmap.mapData;
        this.succeeUpload({
          map_file: src,
          img_type: 'svg',
        });
        let shapeDataArray = await OwllySvgUtil.toDataJson(svg);
        shapeDataArray = shapeDataArray.map(e => e.getData());
        const blobURL = new Blob([JSON.stringify(shapeDataArray)], { type: 'text/json' });
        let base64 = await this.blobToDataURI(blobURL);
        base64 = base64.split('data:text/json;base64,').pop();
        const alignParamsKeyName = ALIGN_SOURCE_MAP[this.source];
        const name = `${this.floorInfo[0].name}_${this.floorInfo[1].floor}_${this.floorInfo[1].id}_cmap_${shortid.generate()}.json`;
        const res = await uploadBase64(name, base64);
        await updateFloor({
          data: {
            id: this.floorId,
            [alignParamsKeyName]: this.jsonData,
            floor_cmap_json: res.data.data[0].url,
          },
        });
        this.$message.success('应用成功');
      } catch (error) {
        this.$message.error('应用异常');
        console.log(error);
      }
    },
    // 地图应用
    async mapApply() {
      this.$confirm('确认应用', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async (e) => {
        await this.initBmapData();
      }).catch((e) => {
        console.log(e);
      });
    },
    async downLoadSvg() {
      const data = await Axios.get(this.imgUrl, {
        responseType: 'document',
      });

      if (data.status !== 200) return;

      // 计算svg的下载名字 场名称_场id_楼层id.svg
      let placeName = '';
      if (this.floorInfo) {
        if (this.floorInfo.length) {
          placeName = this.floorInfo[0].name;
        }
      }
      const downLoadName = `${placeName}_${this.placeId}_${this.floorId}.svg`;

      // 插入一个0 0 4000 4000的矩形 sketch识别别不了svg的viewBox
      const rect = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
      rect.setAttribute('x', 0);
      rect.setAttribute('y', 0);
      rect.setAttribute('width', 4000);
      rect.setAttribute('height', 4000);
      rect.setAttribute('fill', 'none');
      rect.setAttribute('stroke', 'none');
      rect.setAttribute('id', '$canvas_out');
      data.data.querySelector('g').insertBefore(rect, data.data.querySelector('g').querySelector('g'));

      // 设置id等于name 删除无用属性 这样svg才可以在次上传进来
      [...data.data.querySelectorAll('*')].forEach((node) => {
        const name = node.getAttribute('name');
        const properties = node.getAttribute('properties');
        const hz = node.getAttribute('hz');
        if (name) {
          node.setAttribute('id', name);
          node.removeAttribute('name');
        }
        if (properties) {
          node.removeAttribute('properties');
        }
        if (hz) {
          node.removeAttribute('hz');
        }
      });

      // 下载svg
      const url = URL.createObjectURL(new Blob([new XMLSerializer().serializeToString(data.data)]));
      const a = document.createElement('a');
      a.download = downLoadName;
      a.href = url;
      a.click();
      URL.revokeObjectURL(url);
    },
    // 地图编辑
    mapEdit() {
      if (!this.$route.query.place_id) return;
      // window.open(`${window.location.origin}/bmap-editor/#/graphic-editor?place_id=${this.$route.query.place_id}&floor_id=${this.$route.query.floor_id}`);
      window.open(`https://screen.aibee.cn/bmap-editor/#/graphic-editor?place_id=${this.$route.query.place_id}&floor_id=${this.$route.query.floor_id}`);
    },
    roadEdit() {
      this.$router.push({ path: '/map/newMapRouter',
        query: {
          place_id: this.$route.query.place_id,
          floor_id: this.$route.query.floor_id,
          vr_id: this.$route.query.vr_id,
          from: 'bmap_editor',
        } });
    },
  },
  beforeDestroy() {
    this.unbindEvent();
    this.initData = null;
    if (this.stage) this.stage.dispose();
  },
};
</script>
<style lang="less" scoped>
.mapAlign {
  width: 100%;
  display: flex;
  flex-direction: column;
  .mapBox {
    flex: 1;
    position: relative;
    display: flex;
    .canvasBox {
      flex: 1;
      #canvas2D {
        position: absolute;
        left: 0;
        top: 0;
      }
      #canvas3D {
        position: absolute;
        left: 0;
        top: 0;
        z-index: 1;
      }
    }

    .mapAlignFormPanel {
    }
  }
  .button-box {
    position: absolute;
    right: 24px;
  }
}
</style>
